import { createReducer, on } from '@ngrx/store';
import * as fromAuthActions from '../actions/auth.actions';
import * as fromAccountActions from '../actions/account.actions';
import { UserProfile } from 'src/app/models/user-profile.model';

export const featureKey = 'account';

export interface State {
  user: UserProfile;
  documents: {
      data: any,
      isLoaded: Boolean
  };
  qrs: {
      data: any,
      isLoaded: Boolean
  };
}

export const initialState: State = {
  user: null,
  documents: {
      data: null,
      isLoaded: false
  },
  qrs: {
      data: null,
      isLoaded: false
  },
};

export const reducer = createReducer(
  initialState,  
  on(fromAccountActions.updateUserProfileSuccess, (state: State, props: any) => ({
    ...state,
    user: props.data
  })),
  on(fromAccountActions.getDocumentsSuccess, (state: State, props: any) => ({
      ...state,
      documents: {data: props.data, isLoaded: true}
  })),
  on(fromAccountActions.getQRsSuccess, (state: State, props: any) => ({
      ...state,
      qrs: {data: props.data, isLoaded: true}
  })),
  on(fromAuthActions.autoLogout, (state: State, props) => initialState)
);
